import { render, staticRenderFns } from "./tearchDetail.vue?vue&type=template&id=6b9d0406&scoped=true"
import script from "./tearchDetail.vue?vue&type=script&lang=js"
export * from "./tearchDetail.vue?vue&type=script&lang=js"
import style0 from "./tearchDetail.vue?vue&type=style&index=0&id=6b9d0406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d0406",
  null
  
)

export default component.exports